const configuredApiUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, '')
const isLocalClient = ['localhost', '127.0.0.1'].includes(window.location.hostname)

export const API_URL = configuredApiUrl || (isLocalClient ? 'http://localhost:3002' : 'https://api.nokitaito.fi')
